type HandoutIconName =
  | 'audio'
  | 'video'
  | 'presentation'
  | 'document'
  | 'generic'
  | 'image'

type HandoutDTO = {
  /** Filename of the handout */
  filename: string
  /** Relative path to the file */
  url: string
  /** Name of the file icon */
  icon_name?: HandoutIconName
  /** Uploaded but not shared with the audience yet */
  hidden_p: boolean
}

type Handout = {
  name: string
  url: string
  iconName: HandoutIconName
}

const mapDTOToHandout = (dto: HandoutDTO): Handout => ({
  name: dto.filename,
  url: dto.url,
  iconName: dto.icon_name || 'generic',
})

export { type Handout, type HandoutDTO, type HandoutIconName, mapDTOToHandout }
